import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Wrapper = styled.div(
  (props: { withIllustration: boolean }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${props.withIllustration ? '4em' : '1em'};
    text-align: center;
    max-width: 500px;
    justify-self: center;
    gap: 0.5em;

    & > div {
      max-width: 450px;
    }

    & > h3 {
      margin-top: 1.5em;
    }

    & > h4 {
      margin-top: 0.5em;
      width: 65%;

      @media screen and (max-width: ${bp.medium}) {
        width: 100%;
      }
    }
  `
)
